module.exports = __webpack_public_path__ + "media/src/img/payment/pp-9f1dcf83b5083f00ed907187f69e466d.png";